export const LOG_IN = "LOG_IN";
export const GET_USER = "GET_USER";
export const SIGN_OUT = "SIGN_OUT";
export const SET_REFRESH_TOKEN = "SET_REFRESH_TOKEN";
